module.exports = __webpack_public_path__ + "static/media/credit-card-front.2566d073.png";